import { LogoutOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import TaggedButton from '@components/TaggedButton';
import GlobalStateContainer from '@containers/GlobalStateContainer';

import routeNames from '@modules/router/src/routeNames';

import { userDataQuery } from '../../auth/src/authQueries';

const { Text } = Typography;

const RightContent = () => {
  const { removeAllCookies } = GlobalStateContainer.useContainer();
  const navigate = useNavigate();
  const { data: userData } = userDataQuery();

  const onLogout = () => {
    removeAllCookies();

    navigate(routeNames.home);
  };

  const renderWelcomeMsg = () => {
    const username = userData?.name || 'N/A';

    return (
      <Text className="mr-3">{`Welcome, ${username}`}</Text>
    );
  };

  return (
    <div>
      {renderWelcomeMsg()}
      <TaggedButton
        tag="logout"
        icon={<LogoutOutlined />}
        type="primary"
        onClick={onLogout}
      >
        Logout
      </TaggedButton>
    </div>
  );
};

export default RightContent;
